import AvatarDisplay from "components/avatar/display";
import { formatName } from "utils/index";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "ui/components/tooltip";

export const AssigneeCell = ({ row }) => {
    if (row.original?.assigned_to == null) return;
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <AvatarDisplay className="w-7 h-7" user={row.original?.assigned_to} />
                </TooltipTrigger>
                <TooltipContent>
                    <p>{formatName(row.original?.assigned_to)}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export const CreatedCell = ({ row }) => {
    if (row.original?.user_created == null) return;
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <AvatarDisplay className="w-7 h-7" user={row.original?.user_created} />
                </TooltipTrigger>
                <TooltipContent>
                    <p>{formatName(row.original?.user_created)}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
